import React from 'react'
import { withTheme, DefaultTheme } from 'styled-components'
import Select, { StylesConfig, OptionProps, ControlProps, SingleValueProps } from 'react-select'

interface CustomTheme extends DefaultTheme {
  colors: {
    secondary: string
    dark: string
    border: string
  }
}

const defaultOptions = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
]

const getCustomStyles = (theme: CustomTheme, userDarkMode: boolean): StylesConfig => {
  return {
    option: (provided: any, state: OptionProps) => ({
      ...provided,
      color: state.isSelected ? theme.colors.secondary : theme.colors.dark,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: theme.colors.border,
      }
    }),
    control: (provided: any, state: ControlProps) => ({
      ...provided,
      backgroundColor: 'transparent',
      border: `0px solid transparent !important`,
      borderRadius: 5,
      paddingRight: '0px !important',
      width: '100%',
      outline: 'none',
      height: 40,
      minHeight: 40,
      boxShadow: 'none',
    }),
    singleValue: (provided: any, state: SingleValueProps) => {
      const color = userDarkMode ? 'rgba(255,255,255,0.75)' : 'rgba(25,25,27,0.75)'
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'
      return { ...provided, color, opacity, transition }
    },
  }
}

interface SelectStyledProps {
  theme: CustomTheme
  name?: string
  options?: typeof defaultOptions
  userDarkMode?: boolean
  [key: string]: any
}

const SelectStyled = ({
  theme,
  name = 'item',
  options = defaultOptions,
  userDarkMode,
  ...rest
}: SelectStyledProps) => {
  return (
    <Select
      styles={getCustomStyles(theme, userDarkMode || false)}
      defaultValue={options[0]}
      name={name}
      options={options}
      {...rest}
    />
  )
}

export default withTheme(SelectStyled)
